import { useLocation } from 'react-router-dom';

export type Lang = 'ja' | 'en';

export const useLocale = (): Lang => {
  const params = new URLSearchParams(useLocation().search);
  return params.get('lang') === 'en' ? 'en' : 'ja';
};
